import * as actions from './actions';

import { ActionType, createReducer } from 'typesafe-actions';

import { ACTION_STATUSES } from 'shared/consts/consts';
import { BuildingState } from 'store/building/types';

export const INITIAL_STATE: BuildingState = {
  building: null,
  serviceBuilding: null,
  getBuilding: {
    status: null,
    error: null,
  },
};

const getBuildingRequestHandler = (state: BuildingState): BuildingState => ({
  ...state,
  getBuilding: {
    error: null,
    status: ACTION_STATUSES.PENDING,
  },
});

const getBuildingSuccessHandler = (
  state: BuildingState,
  { payload }: ActionType<typeof actions.getBuilding.success>,
): BuildingState => ({
  ...state,
  building: payload,
  getBuilding: {
    error: null,
    status: ACTION_STATUSES.FULFILLED,
  },
});

const getBuildingFailureHandler = (
  state: BuildingState,
  { payload }: ActionType<typeof actions.getBuilding.failure>,
): BuildingState => ({
  ...state,
  getBuilding: {
    error: payload.error,
    status: ACTION_STATUSES.REJECTED,
  },
});

/**
 * Handler for service building context from providers response.
 * Used for cross-building bookings to get service building's timezone/currency.
 */
const setServiceBuildingFromContextHandler = (
  state: BuildingState,
  { payload }: ActionType<typeof actions.setServiceBuildingFromContext>,
): BuildingState => ({
  ...state,
  serviceBuilding: {
    uuid: payload.uuid,
    name: payload.name,
    timezone: payload.timezone,
    locale: payload.locale,
    currency_type: payload.currency_type,
    portfolio_uuid: payload.portfolio_uuid,
  },
});

/**
 * Handler to clear service building context.
 * Used when switching to same-building bookings to prevent stale data.
 */
const clearServiceBuildingHandler = (state: BuildingState): BuildingState => ({
  ...state,
  serviceBuilding: null,
});

const BuildingReducer = createReducer(INITIAL_STATE)
  .handleAction(actions.getBuilding.request, getBuildingRequestHandler)
  .handleAction(actions.getBuilding.success, getBuildingSuccessHandler)
  .handleAction(actions.getBuilding.failure, getBuildingFailureHandler)
  .handleAction(actions.setServiceBuildingFromContext, setServiceBuildingFromContextHandler)
  .handleAction(actions.clearServiceBuilding, clearServiceBuildingHandler);

export default BuildingReducer;
